import { DataBean } from "../DataBean";

export class CloseProcessCycle extends DataBean {



    public async closeProcessPeriod(year:any,month:any,processType:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.ProcessCycle_closeProcessPeriod_Number_Number_Number_Number", [year,month,processType,idEmployee]);
    }
}